import axios from 'axios'

export default new class CloudprinterService {
  getProducts () {
    return axios.post('/products', {})
  }

  getCategories () {
    return axios.post('/categories', {})
  }

  getOrders () {
    return axios.post('/orders', {})
  }

  getOrder (reference) {
    return axios.post('/orders/info', { reference })
  }

  getProductInfo (productReference) {
    const requestData = { 'product_reference': productReference }
    return axios.post('/products/info', requestData)
  }

  orderCreate (orderData) {
    return axios.post('/orders/add', orderData)
  }

  orderQuote (orderQuoteData) {
    return axios.post('/orders/quote', orderQuoteData)
  }

  priceCheck (priceCheckData) {
    return axios.post('/prices/lookup/', priceCheckData)
  }

  getCountries () {
    return axios.post('/shipping/countries', {})
  }

  getStates (countryReference) {
    const data = { 'country_reference': countryReference }
    return axios.post('/shipping/states', data)
  }

  getReorderCauses () {
    return axios.post('/reorder/causes', {})
  }

  orderCancel (orderReference) {
    const data = { 'reference': orderReference }
    return axios.post('/orders/cancel', data)
  }
}()
